import React, { Fragment, useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createProfile, getCurrentProfile } from '../../actions/profile';

const initialState = {
  website: '',
  location: '',
  // skills: '',
  relationship: '',
  bio: '',
  twitter: '',
  facebook: '',
  linkedin: '',
  instagram: ''
};

const ProfileForm = ({
  profile: { profile, loading },
  createProfile,
  getCurrentProfile,
  auth: { user },
  history
}) => {
  const [formData, setFormData] = useState(initialState);

  const [displaySocialInputs, toggleSocialInputs] = useState(false);

  useEffect(() => {
    if (!profile) getCurrentProfile();
    if (!loading && profile) {
      const profileData = { ...initialState };
      for (const key in profile) {
        if (key in profileData) profileData[key] = profile[key];
      }
      for (const key in profile.social) {
        if (key in profileData) profileData[key] = profile.social[key];
      }
      setFormData(profileData);
    }
  }, [loading, getCurrentProfile, profile]);

  const {
    website,
    location,
    // skills,
    relationship,
    bio,
    twitter,
    facebook,
    linkedin,
    instagram
  } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    createProfile(formData, history, profile ? true : false);
  };

  return (
    <div className="profile-form-container">
      <div className="form-header">
        <h3 className="mt-4">Edit Your Profile</h3>
        <h5 className="">
          <i className="fas fa-user-edit"></i> Add or remove personal info
        </h5>
      </div>

      {/* <small>* = required field</small> */}
      <div className="d-flex my-4 justify-content-center">
        <div className="card bg-transparent border-0">
          <img
            src={user.avatar}
            className="rounded-circle card-img img-thumbnail shadow-sm"
            style={{ height: '100px', width: '100px' }}
            alt=""
          />
        </div>

        <div className="ml-4 align-self-center">
          <p className="my-0 text-muted"></p>
          <button
            type="button"
            className="btn btn-primary btn-sm rounded-pill"
            disabled
          >
            <i className="fas fa-plus-circle"></i> Upload Photo
          </button>
          <small id="uploadpichelp" className="form-text text-muted">
            Upload functionality coming soon
          </small>
        </div>
      </div>
      <hr />
      <form className="profile-form" onSubmit={onSubmit}>
        <div className="form-group row">
          <label
            htmlFor="edit-current-city"
            className="col-sm-2 col-form-label col-form-label-sm text-md-right"
          >
            Current City/State
          </label>
          <div className="col-10 col-md-6 col-lg-5">
            <input
              type="text"
              className="form-control form-control-sm"
              id="edit-current-city"
              name="location"
              value={location}
              onChange={onChange}
              aria-describedby="currentcityhelp"
            />
            <small id="currentcityhelp" className="form-text text-muted">
              City, ST format recommended (ex. Tampa, FL)
            </small>
          </div>
        </div>
        <div className="form-group row">
          <label
            className="col-sm-2 col-form-label col-form-label-sm text-md-right"
            htmlFor="edit-bio"
          >
            Bio
          </label>
          <div className="col-10 col-md-6 col-lg-5">
            <textarea
              className="form-control form-control-sm"
              id="edit-bio"
              rows="2"
              name="bio"
              value={bio}
              onChange={onChange}
              aria-describedby="biohelp"
            ></textarea>
            <small id="biohelp" className="form-text text-muted">
              Tell us a little about yourself or add a favorite quote
            </small>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="edit-relationship"
            className="col-sm-2 text-md-right col-form-label col-form-label-sm"
          >
            Relationship Status
          </label>
          <div className="col-10 col-md-6 col-lg-5">
            <select
              className="custom-select custom-select-sm"
              name="relationship"
              value={relationship}
              onChange={onChange}
            >
              <option>Select Relationship Status</option>
              <option value="Single">Single</option>
              <option value="It's complicated">It's complicated</option>
              <option value="In a relationship">In a relationship</option>
              <option value="Married">Married</option>
              <option value="Separated">Separated</option>
              <option value="Divorced">Divorced</option>
            </select>
          </div>
        </div>
        {/* <div className="form-group row">
          <label
            htmlFor="edit-skills"
            className="col-sm-2 col-form-label col-form-label-sm text-md-right"
          >
            Skills
          </label>
          <div className="col-10 col-md-6 col-lg-5">
            <input
              type="text"
              className="form-control form-control-sm"
              id="edit-skills"
              name="skills"
              value={skills}
              onChange={onChange}
              aria-describedby="skillshelp"
            />
            <small id="skillshelp" className="form-text text-muted">
              Please use comma separated values (eg. HTML,CSS,JavaScript,PHP)
            </small>
          </div>
        </div> */}
        <div className="my-4">
          {displaySocialInputs ? (
            <button
              onClick={() => toggleSocialInputs(!displaySocialInputs)}
              type="button"
              className="btn btn-light btn-sm rb mx-3 shadow-sm"
            >
              Add Social Media <i className="fas fa-caret-up"></i>
            </button>
          ) : (
            <button
              onClick={() => toggleSocialInputs(!displaySocialInputs)}
              type="button"
              className="btn btn-light btn-sm rb mx-3 shadow-sm"
            >
              Add Social Media <i className="fas fa-caret-down"></i>
            </button>
          )}
          <span className="rb">Optional</span>
        </div>

        {displaySocialInputs && (
          <Fragment>
            <div className="my-4 social edit-social">
              <div className="form-group row">
                <label
                  htmlFor="edit-twitter"
                  className="col-1 col-sm-2 col-form-label col-form-label-sm text-md-right"
                >
                  <i className="fab fa-twitter fa-2x twitter" />
                </label>
                <div className="col-10 col-md-6 col-lg-5">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="edit-twitter"
                    placeholder="Twitter URL"
                    name="twitter"
                    value={twitter}
                    onChange={onChange}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="edit-facebook"
                  className="col-1 col-sm-2 col-form-label col-form-label-sm text-md-right"
                >
                  <i className="fab fa-facebook fa-2x facebook" />
                </label>
                <div className="col-10 col-md-6 col-lg-5">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="edit-facebook"
                    placeholder="Facebook URL"
                    name="facebook"
                    value={facebook}
                    onChange={onChange}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="edit-linkedin"
                  className="col-1 col-sm-2 col-form-label col-form-label-sm text-md-right"
                >
                  <i className="fab fa-linkedin fa-2x linkedin" />
                </label>
                <div className="col-10 col-md-6 col-lg-5">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="edit-linkedin"
                    placeholder="LinkedIn URL"
                    name="linkedin"
                    value={linkedin}
                    onChange={onChange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label
                  htmlFor="edit-instagram"
                  className="col-1 col-sm-2 col-form-label col-form-label-sm text-md-right"
                >
                  <i className="fab fa-instagram fa-2x instagram" />
                </label>
                <div className="col-10 col-md-6 col-lg-5">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="edit-instagram"
                    placeholder="Instagram URL"
                    name="instagram"
                    value={instagram}
                    onChange={onChange}
                  />
                </div>
              </div>
            </div>
          </Fragment>
        )}
        <div>
          <input type="submit" className="btn btn-primary btn-sm my-1 mr-3" />
          <Link className="btn btn-light btn-sm my-1 shadow-sm" to="/dashboard">
            Cancel
          </Link>
        </div>
      </form>
    </div>
  );
};

ProfileForm.propTypes = {
  createProfile: PropTypes.func.isRequired,
  getCurrentProfile: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  profile: state.profile,
  auth: state.auth
});

export default connect(mapStateToProps, { createProfile, getCurrentProfile })(
  withRouter(ProfileForm)
);
